// extracted by mini-css-extract-plugin
export default {"root":"EventDetailsPage_root__ABums","restricted":"EventDetailsPage_restricted__rPmVW"};